import React from "react";
import TableViewPage from "./TableViewPage";
import danniNAP from "../assets/excel/Danni_NAP.xlsx";

const DanniNAPTablePage = () => {
  return (
    <TableViewPage
      excelFile={danniNAP}
      title="Осигурителен доход и заетост по общини (НАП)"
      headerRow={0}
    />
  );
};

export default DanniNAPTablePage;